import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { withRouter } from "react-router-dom";

import ForgotPasswordLayout from "./components/ForgotPasswordLayout";
import HalfLayout from "components/HalfLayout";
import RocketLayout from "components/RocketLayout";
import paths from "routes/paths";

class ForgotPassword extends React.Component {
  componentWillMount = () => {
    if (this.props.isAuthenticated) this.props.push(paths.front.home);
  };

  render() {
    return (
      <HalfLayout
        leftComponent={<RocketLayout location={this.props.location} />}
        rightComponent={<ForgotPasswordLayout location={this.props.location} />}
      />
    );
  }
}

ForgotPassword.defaultProps = {
  isAuthenticated: false,
};

ForgotPassword.propTypes = {
  isAuthenticated: PropTypes.bool,
  push: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Authentication.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => ({
  push: (route) => dispatch(push(route)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
);
